import React from 'react';

function Education() {
    return ( 
        <div className='container' >
            <div className='row'>
                <div className='col-6'>
                    <img src='media/Education.svg' alt='Education'></img>
                </div>
                <div className='col-6 mt-5 p-3'>
                    <h2>Free and open market education</h2>
                    <div className='row mt-3'>
                        <p>Varsity, the largest online stock market education book in the world covering everything from the basics to advanced trading.</p>
                        <a href='#' style={{textDecoration:"none"}}>Varsity </a>
                    </div>
                    <div className='row mt-4'>
                        <p>TradingQ&A, the most active trading and investment community in India for all your market related queries.</p>
                        <a href='#' style={{textDecoration:"none"}}>TradingQ&A  </a>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Education;